<div class="ecs-table-container">
	@if (services().length === 0) {
	<div class="empty-state">
		<i class="bi bi-inbox text-4xl opacity-30"></i>
		<p class="text-sm text-[var(--text-secondary)]">No streaming ECS services configured</p>
	</div>
	} @else {
	<div class="table-actions">
		<button class="btn-bulk btn-bulk-start" [disabled]="isBulkActionInProgress()" (click)="startAllServices()">
			@if (isBulkActionInProgress()) {
			<i class="bi bi-arrow-repeat spinner"></i>
			<span>Processing...</span>
			} @else {
			<i class="bi bi-play-fill"></i>
			<span>Start All</span>
			}
		</button>
		<button class="btn-bulk btn-bulk-stop" [disabled]="isBulkActionInProgress()" (click)="stopAllServices()">
			@if (isBulkActionInProgress()) {
			<i class="bi bi-arrow-repeat spinner"></i>
			<span>Processing...</span>
			} @else {
			<i class="bi bi-stop-fill"></i>
			<span>Stop All</span>
			}
		</button>
	</div>

	<div class="table-responsive">
		<table class="ecs-table">
			<thead>
				<tr>
					<th>Service ID</th>
					<th>Service Name</th>
					<th>Status</th>
					<th class="text-center">Action</th>
				</tr>
			</thead>
			<tbody>
				@for (service of services(); track service.id) {
				<tr>
					<td class="service-id">{{ service.id }}</td>
					<td class="service-label">{{ service.label }}</td>
					<td>
						@if (isServiceRunning(service)) {
						<span class="status-badge status-running">
							<i class="bi bi-circle-fill"></i>
							Running
						</span>
						} @else {
						<span class="status-badge status-stopped">
							<i class="bi bi-circle-fill"></i>
							Stopped
						</span>
						}
					</td>
					<td class="text-center">
						@if (isServiceRunning(service)) {
						<button class="btn-action btn-stop"
							[disabled]="isActionInProgress(service.id) || isBulkActionInProgress()"
							(click)="stopService(service)">
							@if (isActionInProgress(service.id)) {
							<i class="bi bi-arrow-repeat spinner"></i>
							<span>Processing...</span>
							} @else {
							<i class="bi bi-stop-circle"></i>
							<span>Stop</span>
							}
						</button>
						} @else {
						<button class="btn-action btn-start"
							[disabled]="isActionInProgress(service.id) || isBulkActionInProgress()"
							(click)="startService(service)">
							@if (isActionInProgress(service.id)) {
							<i class="bi bi-arrow-repeat spinner"></i>
							<span>Processing...</span>
							} @else {
							<i class="bi bi-play-circle"></i>
							<span>Start</span>
							}
						</button>
						}
					</td>
				</tr>
				}
			</tbody>
		</table>
	</div>
	}
</div>
